<p>correspondenceteam-container works!</p>
<dashboardnav>

    <cradua-correspondenceteam
    [correspondenceTeams]="correspondenceTeams$ | async"
    (correspondenceTeam)="onSubmitCorrespondenceTeam($event)"
    (deleteCorrespondenceTeamEvent)="onDeleteCorrespondenceTeam($event)"
    *ngIf="(isLoadingCorrespondenceTeam$ | async ) === false"
    >
  </cradua-correspondenceteam>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingCorrespondenceTeam$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
